import * as React from 'react';
import styled from 'styled-components';

import { AlertBox } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

import {
  passwordIsLongEnough,
  passwordContainsNumber,
  passwordContainsUpper,
  passwordContainsLower,
} from 'ts/passwordless-login/services/passwordvalidation/PasswordValidationService';
import { PasswordStrengthIndicatorRule } from './PasswordStrengthIndicatorRule';

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({
  password = '',
}) => {
  const longEnough = passwordIsLongEnough(password);
  const containsNumber = passwordContainsNumber(password);
  const containsUpper = passwordContainsUpper(password);
  const containsLower = passwordContainsLower(password);
  return (
    <Box display="inlineFlex" width="100%" height="58px">
      <FirstRuleColumn>
        <PasswordStrengthIndicatorRule
          displayText="Min 8 characters"
          isValid={longEnough}
          data-id="passwordLengthField"
        />
        <PasswordStrengthIndicatorRule
          displayText="Min 1 number"
          isValid={containsNumber}
          data-id="containsNumberField"
        />
      </FirstRuleColumn>
      <div>
        <PasswordStrengthIndicatorRule
          displayText="Min 1 uppercase"
          isValid={containsUpper}
          data-id="containsUpperField"
        />
        <PasswordStrengthIndicatorRule
          displayText="Min 1 lowercase"
          isValid={containsLower}
          data-id="containsLowerField"
        />
      </div>
    </Box>
  );
};

const FirstRuleColumn = styled.div`
  width: 180px;
`;
const PasswordSecureWrapper = styled.div`
  width: 100%;
`;
